export const SET_SESSION = 'CS/IDENTITY_SET_SESSION';
export const DELETE_SESSION = 'CS/IDENTITY_DELETE_SESSION';
export const SET_CONFIG = 'CS/IDENTITY_SET_CONFIG';
